import { useEffect } from "react";

import { client } from "@client";
import { MAX_PREFETCH_QUERIES, NODE_COUNT } from "@constants";
import { PortfolioPerformanceGraphQuery, PortfolioPerformanceGraphQueryVariables } from "@ctypes";
import { GOAL_DETAILS_BREAKDOWN } from "@graphql";
import { useUser } from "@hooks/user";
import { useGoalsContext } from "./useGoalsContext";

export const useGoalDetailsPrefetch = () => {
  const { beneficiaryId } = useGoalsContext();

  const { beneficiaries } = useUser();

  const beneficiary = beneficiaries?.find((beneficiary) => beneficiary?.id === beneficiaryId);

  useEffect(() => {
    if (!beneficiary) return;

    beneficiary.goals?.forEach((goal, index) => {
      if (index >= MAX_PREFETCH_QUERIES) return;

      const goalId = goal?.id;

      if (goalId) {
        client.query<PortfolioPerformanceGraphQuery, PortfolioPerformanceGraphQueryVariables>({
          query: GOAL_DETAILS_BREAKDOWN,
          variables: {
            beneficiaryId,
            goalId,
            nodeCount: NODE_COUNT,
          },
        });
      }
    });
  }, []);
};
